import { ref } from 'vue';
import { storeToRefs } from 'pinia';

import type { IBhs, IIBhs } from '@/modules/settings/interfaces/BusinessHours';
import { useMailboxesStore } from '@/modules/settings/stores/mailboxes';
import { weekdaysFormat } from '@/modules/settings/utils/parser/bhs';

const useBusinessHours = () => {
    const storeMailboxes = useMailboxesStore();
    const { mailboxes } = storeToRefs(storeMailboxes);
    const enabled = ref(true);

    const getBusinessHours = async (mailbox: string): Promise<IBhs> => {
        const m = mailboxes.value.find((m) => m.email === mailbox);
        const data = {
            businessHours: m!.bhs.businessHours,
            timezone: m!.bhs.timezone
        };
        storeMailboxes.setMailboxBusinessHours(mailbox, data);
        return data;
    };

    const createBusinessHours = async (businessHours: IIBhs): Promise<void> => {
        const bh = businessHours.business_hours.filter((businessHour) => businessHour.start_time === '00:00:00' && businessHour.end_time === '23:59:59');

        if (bh.length === 7) {
            businessHours.mailboxes?.forEach(async (mailbox: string) => {
                const m = mailboxes.value.find((m) => m.email === mailbox);
                m!.bhsStatus = 'Ignored';

                storeMailboxes.setMailboxBusinessHours(
                    mailbox,
                    weekdaysFormat({
                        business_hours: [],
                        timezone: 'UTC'
                    })
                );
            });
        } else {
            businessHours.mailboxes?.forEach(async (mailbox: string) => {
                storeMailboxes.setMailboxBhsStatus(mailbox);
                storeMailboxes.setMailboxBusinessHours(
                    mailbox,
                    weekdaysFormat({
                        business_hours: businessHours.business_hours,
                        timezone: businessHours.timezone
                    })
                );
            });
        }
    };

    const deleteBusinessHours = async (mailboxesParams: string[]): Promise<void> => {
        mailboxesParams.forEach(async (mailbox: string) => {
            const m = mailboxes.value.find((m) => m.email === mailbox);
            m!.bhsStatus = 'Company';

            storeMailboxes.setMailboxBusinessHours(
                mailbox,
                weekdaysFormat({
                    business_hours: [],
                    timezone: 'UTC'
                })
            );
        });
    };

    return {
        // properties
        enabled,

        // Method
        getBusinessHours,
        createBusinessHours,
        deleteBusinessHours
    };
};

export default useBusinessHours;
